<div *ngIf="!dialogApplications">
    <div
         *ngIf="!dialogApplications"
         class="ui-g-12 ui-lg-12 text-right"
         style="float:unset;">
        <button pButton type="button"
                class="k-generic-btn"
                icon="fa fa-angle-left"
                iconPos="left"
                (click)="onCustomButton()"
                label="{{ 'common.back' | translate }}"></button>
    </div>
    <app-kontable
        *ngIf="!dialogApplications"
        id="dt_user_companies"
        title="{{ 'userCompanies.sectionTitle' | translate }}"
        [columns]="['name',
            { field: 'date_start', bodyTemplate: dateField, title: 'userApplications.date_start' },
            { field: 'date_end', bodyTemplate: dateField, title: 'userApplications.date_end' }
        ]"
        [titles]="['common.name', 'userCompanies.date_start', 'userCompanies.date_end']"
        [source]="selectedCompaniesClone"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showInfoButton]="false"
        [(fireNewDataAvailable)]="newDataAvailable"
        [additionalRowCommands]="customRow"
        (onAdd)="openDialog($event)"
        (onEdit)="openDialog($event)"
        (onRemove)="deleteElement($event)">
        <ng-template #customRow data-testid="customRow" let-row>
            <p-button label="" icon="fa fa-laptop" styleClass="ui-button-info" (onClick)="companiesApplication(row)"></p-button>
        </ng-template>
        <ng-template #dateField data-testid="dateField" let-row let-value="value">{{value | date: srvCalTranslate.pcalendarTranslate.dateFormatFilter }}</ng-template>
    </app-kontable>
    <p-dialog
            *ngIf="showDialog"
            [(visible)]="showDialog"
            [modal]="true"
            [minWidth]="500"
            [draggable]="false"
            [resizable]="false"
            (onHide)="closeDialog()"
            [header]="dialogTitle">
        <app-user-companies-form
                (companiesAdded)="userCampainesAdded($event)"
                (companiesUpdated)="userCampainesUpdateed($event)"
                *ngIf="showDialog"
                [dialogBox]="selectedRow">
        </app-user-companies-form>
    </p-dialog>
</div>

<app-user-applications
        *ngIf="dialogApplications"
        [selectedApplications]="selectedApplications"
        [selectedCompany]="selectedCompany"
        (onBackPressed)="dialogApplications = false"
        [activeUser]="activeUser"
></app-user-applications>



// WEBPACK FOOTER //
// ./src/app/views/administration/users/userCompanies.component.html